<template>
    <a
        :href="resolvedHref"
        @click="click"
        class="no-underline text-white py-2 px-4 rounded-md inline-block font-medium transition-opacity text-center"
        :class="disabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'"
        :style="{ backgroundColor: typeStyles.bg, color: typeStyles.color, minWidth: '200px' }"
    >
        <slot />
    </a>
</template>

<script>
export default {
    name: 'LinkButton',

    props: {
        href: {
            type: String,
            default: '#',
        },
        type: {
            type: String,
            default: 'green',
            validator: (v) => ['orange', 'green', 'grey'].includes(v),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        click(event) {
            if (this.disabled) {
                if (event) event.preventDefault();
                return;
            }
            if (event && (this.href === '#' || this.href === '')) {
                event.preventDefault();
            }

            this.$emit('click', event);
        },
    },

    computed: {
        resolvedHref() {
            if (this.disabled) return undefined;
            if (this.href === '#' || this.href === '') return 'javascript:void(0)';
            return this.href;
        },
        typeStyles() {
            const map = {
                orange: { bg: '#de9e52', color: '#ffffff' },
                green:  { bg: '#2b8189', color: '#ffffff' },
                grey:   { bg: '#e5e7eb', color: '#000000' },
            };
            return map[this.type] || map.green;
        },
    },
};
</script>
